"use client";
import { HISTORY_TEMPLATES } from "@/lib/constants";
import { HistoryCategory } from "@/lib/types";
import {
  Box,
  Button,
  Center,
  Heading,
  HStack,
  Spinner,
  VStack,
} from "@chakra-ui/react";
import { ReactNode } from "react";
import { FaPlus } from "react-icons/fa6";

const HistorySection = ({
  category,
  isLoading,
  children,
  onClick,
}: {
  category: HistoryCategory;
  isLoading: boolean;
  children: ReactNode;
  onClick: () => void;
}) => {
  return (
    <VStack flexGrow="1" w="100%">
      <HStack w="100%" justifyContent="space-between">
        <Heading fontSize="20px" fontWeight="500">
          {HISTORY_TEMPLATES[category].title}
        </Heading>
        <Button
          leftIcon={<FaPlus />}
          variant="primary"
          fontWeight="500"
          onClick={onClick}
        >
          Add Record
        </Button>
      </HStack>
      <Box mt="16px" mb="20px" height="1px" w="100%" bg="#E4E4E4"></Box>
      {isLoading ? (
        <Center>
          <Spinner />
        </Center>
      ) : (
        children
      )}
    </VStack>
  );
};

export default HistorySection;
